// istanbul ignore file

import { BookingMethod } from './booking-method';
import { EntryMethodPreference, EntryMethodPreferenceOption } from './entry-method-preferences';
import { Property } from './property';

enum NoticeType {
    RequiresAgencyConfirmation = 'REQUIRES_AGENCY_CONFIRMATION',
    RefusingService = 'REFUSING_SERVICE',
    CommunicationDifficulty = 'COMMUNICATION_DIFFICULTY',
    BookingProblemOther = 'BOOKING_PROBLEM_OTHER',
    SameTenantDetails = 'SAME_TENANT_DETAILS',
    UnableToContactOccupantAuto = 'UNABLE_TO_CONTACT_OCCUPANT_AUTO',
    UnableToContactOccupant = 'UNABLE_TO_CONTACT_OCCUPANT',
    TenantRequiresAgencyAttendance = 'TENANT_REQUIRES_AGENCY_ATTENDANCE',
    NoTenantDetails = 'NO_TENANT_DETAILS',
    TenantUnavailableBusinessHours = 'TENANT_UNAVAILABLE_BUSINESS_HOURS',
    DueDateNotCorrectlyUpdated = 'DUE_DATE_NOT_CORRECTLY_UPDATED',
    TenantCancelledConsecutively = 'TENANT_CANCELLED_CONSECUTIVELY',
    RequireUpdateDetailXDays = 'REQUIRE_UPDATE_DETAIL_X_DAYS',
    AccessProblemBadKeys = 'BAD_KEYS',
    Unknown = 'UNKNOWN'
}

type NoticeProperty = Property & {
    isIntegrated: boolean;
    bookingMethod: BookingMethod;
    entryMethodPreferences?: {
        [key in EntryMethodPreference]: EntryMethodPreferenceOption;
    };
};

type Notice = {
    id: number;
    property: NoticeProperty;
    noticeType: NoticeType;
    noticeTypeCategory: string;
    createdAt: string;
    isUrgent: boolean;
    isResolved: boolean;
    isContactDiRequired: boolean;
    occupants: string;
    tags: string[];
};

const contactRequiredTypes = [
    NoticeType.TenantCancelledConsecutively,
    NoticeType.Unknown,
    NoticeType.BookingProblemOther,
];

const updateRequiredTypes = [
    NoticeType.NoTenantDetails,
    NoticeType.SameTenantDetails,
    NoticeType.RequireUpdateDetailXDays,
];

export {
    NoticeType, //
    Notice,
    NoticeProperty,
    contactRequiredTypes,
    updateRequiredTypes,
};
